import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'

// models
import { FilterPiecework } from '@/models/piecework'

@Module({ namespaced: true })
class PieceworkModule extends VuexModule {
	public filtersState: FilterPiecework = {
    date_end: null,
    date_start: null,
    headquarter: null,
    type: null,
		employee: null
  }

  public showFiltersState = false

	get filters () {
		return this.filtersState
	}

  get showFilters () {
    return this.showFiltersState
  }

	@Mutation
	public SET_FILTER (payload: FilterPiecework): void {
    this.filtersState = payload
	}

  @Mutation
	public SET_SHOW_FILTER (payload: boolean): void {
    this.showFiltersState = payload
	}

	@Action
	public async changeFilters (payload: FilterPiecework) {
		this.context.commit('SET_FILTER', payload)
	}

	@Action
	public async clearFilters () {
		this.context.commit('SET_FILTER', {
			date_end: null,
			date_start: null,
			headquarter: null,
			type: null
		})
	}

  @Action
	public async changeShowFilters (payload: boolean) {
		this.context.commit('SET_SHOW_FILTER', payload)
	}
}

export default PieceworkModule
